import React from 'react';

export const onKeyDown=(event,submit)=>{
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      submit();
    }
  }